module.exports = __webpack_public_path__ + "static/media/multi-image-1.bdc55df6.png";